import { useEffect } from 'react'
import { AppTrackingTransparency } from 'capacitor-plugin-app-tracking-transparency'

const UsercentricsLoader = () => {
  useEffect(() => {
    const requestPermissionAndLoadScript = async () => {
      const response = await AppTrackingTransparency.requestPermission()

      if (response.status === 'authorized') {
        loadUsercentricsScript()
      }
    }

    const loadUsercentricsScript = () => {
      if (document.getElementById('usercentrics-cmp')) {
        return
      }

      const script = document.createElement('script')

      script.id = 'usercentrics-cmp'
      script.src = 'https://web.cmp.usercentrics.eu/ui/loader.js'
      script.async = true

      if (process.env.NEXT_PUBLIC_APP_ENV === 'production') {
        script.setAttribute('data-settings-id', 'Mz_ElwOEZM53pj')
      } else {
        script.setAttribute('data-draft', 'true')
        script.setAttribute('data-settings-id', 'Mz_ElwOEZM53pj')
      }

      document.head.appendChild(script)
    }

    if (typeof window !== 'undefined') {
      requestPermissionAndLoadScript()
    }
  }, [])

  return null
}

export default UsercentricsLoader
